import { cognito } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';

export const forgotPassword = createApiSlice<unknown, { username: string }>({
  name: 'forgotPassword',
  *tryGenerator(_, { payload: { username } }) {
    yield call(cognito.forgotPassword, { username });

    return null;
  },
});

export const forgotPasswordSubmit = createApiSlice<
  unknown,
  { username: string; code: string; pass: string }
>({
  name: 'forgotPasswordSubmit',
  *tryGenerator(_, { payload: { username, code, pass } }) {
    yield call(cognito.forgotPasswordSubmit, { username, code, pass });

    return null;
  },
});
